import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Youtube, Mail } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex flex-col mb-4">
              <span className="text-xs text-gray-400 font-medium">Independent Guide</span>
              <span className="text-3xl font-bold text-[#ff444f]">Synthetic Trading Hub</span>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Learn synthetic trading, synthetic indices, and crash boom trading through an educational, risk-aware affiliate guide.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/derivdotcom/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-[#ff444f] transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://x.com/derivdotcom" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-[#ff444f] transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/derivdotcom/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-[#ff444f] transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/derivdotcom/" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-[#ff444f] transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/c/Derivdotcom" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-400 hover:text-[#ff444f] transition-colors" aria-label="YouTube">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Trading */}
          <div>
            <h3 className="text-white font-semibold mb-4">Trading</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="https://deriv.com/markets/synthetic-indices/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">Synthetic Indices</a></li>
              <li><a href="https://deriv.com/markets/synthetics/crash-boom/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">Crash & Boom</a></li>
              <li><a href="https://deriv.com/markets/synthetics/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">Synthetics Markets</a></li>
              <li><a href="https://deriv.com/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">Official Deriv Platform</a></li>
              <li><a href="https://deriv.com/help-centre/" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-[#ff444f] transition-colors">Platform Help</a></li>
            </ul>
          </div>

          {/* Platforms */}
          <div>
            <h3 className="text-white font-semibold mb-4">Platforms</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="https://deriv.com/trading-platforms/dtrader/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">DTrader</a></li>
              <li><a href="https://deriv.com/trading-platforms/Metatrader5/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">Metatrader5</a></li>
              <li><a href="https://deriv.com/trading-platforms/dbot/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">DBot</a></li>
              <li><a href="https://deriv.com/trading-platforms/smarttrader/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">SmartTrader</a></li>
              <li><a href="https://deriv.com/trading-platforms/" target="_blank" rel="noopener noreferrer sponsored nofollow" className="hover:text-[#ff444f] transition-colors">Mobile Apps</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="https://deriv.com/help-centre/" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-[#ff444f] transition-colors">Help Center</a></li>
              <li><a href="https://deriv.com/blog/" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-[#ff444f] transition-colors">Trading Guide</a></li>
              <li><a href="https://deriv.com/payments/" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-[#ff444f] transition-colors">Payment Methods</a></li>
              <li><a href="mailto:contact@synthetictradinghub.com" className="hover:text-[#ff444f] transition-colors">Affiliate Site Contact</a></li>
              <li>
                <a href="mailto:support@deriv.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#ff444f] transition-colors flex items-center" title="Official Deriv support">
                  <Mail className="w-4 h-4 mr-2" />
                  support@deriv.com (Deriv official)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Synthetic Trading Hub. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-[#ff444f] transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-400 hover:text-[#ff444f] transition-colors">Terms of Service</Link>
              <Link to="/risk-disclosure" className="text-gray-400 hover:text-[#ff444f] transition-colors">Risk Disclosure</Link>
            </div>
          </div>
          <div className="mt-6 text-xs text-gray-500">
            <p className="mb-2">
              <strong>Risk Warning:</strong> Trading carries a high level of risk and may not be suitable for all investors. You may lose your invested capital.
            </p>
            <p>
              This website is operated by an independent affiliate partner of Deriv.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
